var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.423 9.267l-8.69-8.69C11.363.207 10.863 0 10.34 0H1.969A1.969 1.969 0 000 1.969v8.372c0 .522.207 1.023.577 1.392l8.69 8.69a1.969 1.969 0 002.784 0l8.372-8.372a1.969 1.969 0 000-2.784zm-.928 1.856l-8.372 8.372a.656.656 0 01-.928 0l-8.69-8.69a.652.652 0 01-.192-.464V1.969c0-.362.294-.657.656-.657h8.372c.175 0 .34.069.464.193l8.69 8.69a.657.657 0 010 .928zM5.906 5.086a.821.821 0 010 1.64.821.821 0 010-1.64zm0-1.149a1.969 1.969 0 100 3.938 1.969 1.969 0 000-3.938z",
    fill: "#3952FA"
  })));
}

export default __webpack_public_path__ + "./fonts/tag.348ed654a2fae5075a5506c1df265c84.svg";
export { SvgTag as ReactComponent };